/* eslint-disable no-unused-vars */

import { useFetchCorporateByID } from '../../utils/queries/corporate';
import CorporateUsersList from '../../components/Corporates/CorporateUsersList.js';
import { useFetchCorporateUsers } from '../../utils/queries/corporateUsers';
import AddCorporateUserModal from '../../components/Corporates/AddCorporateUserModel';
import { Button, Typography, Tabs, Badge } from 'antd';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import UserwiseAnalytics from 'components/Corporates/Analytics/UserwiseAnalytics';
import { Col, Row } from 'reactstrap';
import { setQuarter } from 'date-fns';

const { TabPane } = Tabs;

const { Title } = Typography;

const CorporateUsers = ({ corporateId }) => {
  const history = useHistory();
  const corporateData = {};
  const [pageLimit, setPageLimit] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [queryString, setQueryString] = useState('');
  // const { data: corporateData } = useFetchCorporateByID(corporateId);
  const [chargersData, setChargersData] = useState(null);
  const {
    data: usersData,
    isLoading: isFetchingUsers,
    refetch: refetchUsers,
  } = useFetchCorporateUsers({
    offset: (currentPage - 1) * pageLimit,
    limit: pageLimit,
    query: queryString,
    // corporateId,
  });
  const [activeTab, setActiveTab] = useState('employees');
  const [isAddCorporateUserOpen, setAddCorporateUserOpen] = useState(false);
  const [editCorporateUserObject, setEditCorporateUserObject] = useState(null);

  // const data = [];
  // const {
  //   data = [],
  //   isLoading,
  //   isError,
  //   refetch,
  // } = useFetchCorporateChargersList({
  //   filter: 'all',
  // });

  // useEffect(() => {
  //   if (!chargersData) setChargersData(data);
  // }, [chargersData, data]);

  const openAddUser = (type) => {
    setAddCorporateUserOpen(true);
  };

  const closeAddCorporateUser = () => {
    setEditCorporateUserObject(null);
    setAddCorporateUserOpen(false);
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            marginBottom: 20,
          }}
        >
          <LeftOutlined
            style={{ marginRight: '10px', cursor: 'pointer' }}
            onClick={() => history.goBack()}
          />
          <Title level={2} style={{ margin: '0px' }}>
            Users
            <span style={{ color: '#2375b8', marginLeft: 5 }}>
              {corporateData?.data?.CORPORATE_NAME}
            </span>
          </Title>
        </div>

        {activeTab === 'employees' ? (
          <Button
            type="primary"
            size="large"
            onClick={() => {
              openAddUser('emmployees');
            }}
          >
            Add New User
          </Button>
        ) : (
          <Button
            type="primary"
            size="large"
            onClick={() => {
              openAddUser('admins');
            }}
          >
            Add New Admin
          </Button>
        )}
      </div>

      <div>
        <Row>
          <Col>
            <UserwiseAnalytics />
            <hr />
            <CorporateUsersList
              corporateId={corporateId}
              data={usersData}
              isLoading={isFetchingUsers}
              isAdmin={false}
              setEditCorporateUserObject={setEditCorporateUserObject}
              setAddCorporateUserOpen={setAddCorporateUserOpen}
              setQuery={setQueryString}
              currentPageNo={currentPage}
              pageSize={pageLimit}
              setCurrentPageNo={setCurrentPage}
              setPageSize={setPageLimit}
            />
          </Col>
        </Row>
      </div>
      <AddCorporateUserModal
        type={activeTab}
        corporateId={corporateId}
        editCorporateUserObject={editCorporateUserObject}
        isModalVisible={isAddCorporateUserOpen}
        closeAddCorporateUser={closeAddCorporateUser}
        triggerRefreshList={refetchUsers}
      />
    </>
  );
};

export default CorporateUsers;
